/* istanbul ignore file */
import { TextArea, TextInput, useFormContext } from 'framework/form';
import { SubmitButton } from 'framework/ui/ui-builder';
import { Button } from 'framework/ui/mui-builder';
import { Box } from '@mui/material';

type CloseProcessIssueFormProps = {
  handleCancelClick: () => void;
};

const CloseProcessIssueForm = ({ handleCancelClick }: CloseProcessIssueFormProps) => {
  const { submitForm, isSubmitEnabled, isLoadingArtifact } = useFormContext();

  return (
    <>
      <TextInput source="issueIds" label="Issue id" isRequired disabled />
      <TextArea source="comment" label="Close reason" />
      <Box display="flex" gap={1.25}>
        <SubmitButton
          key="submit-modal-btn"
          onClick={submitForm}
          isLoading={!isSubmitEnabled}
          disabled={isLoadingArtifact}
        />
        <Button
          variant="outlined"
          key="cancel-modal-btn"
          onClick={handleCancelClick}
          disabled={!isSubmitEnabled || isLoadingArtifact}
        >
          Cancel
        </Button>
      </Box>
    </>
  );
};

export default CloseProcessIssueForm;
